<div id="homepage-top">
  <pixie-hero
    [id]="id"
    [title]="title"
    [ctas]="ctas"
  ></pixie-hero>
  <dcl-quick-quote
    class="dcl-quick-quote"
    *ngIf="filters"
    [contextPath]="contextPath"
    [data]="filters"
    (analyticsTrackingEvent)="analyticsTrackingEvent($event)"
    [isDclClRefactorPhase2]="isDclClRefactorPhase2"
  ></dcl-quick-quote>
</div>

<pixie-stories appDeepLink></pixie-stories>